import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { statisticsData } from '../../data/departmentalData/statistics';

const Statistics = () => {
  return <TemplatePage data={statisticsData} />;
};

export default Statistics;
